export function AuroraBackground() {
    return (
        <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none bg-[#FFFBF4] bg-bird-pattern" />
    );
}
